export default ".info-popup-text{font-size:17px}";